/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { SNAP_HOTELS_LIST_PATH } from '../configs/constants';

/**
 * Resolves a SNAP hotels-list href for host `navigateToHotelsList` adapters.
 * Same role as hotels' `resolveListNavigationHref` on web: absolute and path
 * values from the URL builder are kept; a bare query string is mounted on
 * `listPath` (default `/v2/snap/hotels/list`).
 */
export const resolveSnapHotelsListHref = (
  queryString: string,
  listPath: string = SNAP_HOTELS_LIST_PATH,
): string => {
  const trimmed = queryString.trim();

  if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith('/')) {
    return trimmed;
  }

  const query = trimmed.replace(/^\?/, '');
  return query ? `${listPath}?${query}` : listPath;
};
